export default "__VITE_ASSET__CoFrPwic__"